import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <h4>© RIDOY, All Rights Reserved 2022</h4>
        </div>
    );
};

export default Footer;